import { useEffect } from 'react';
import { Flex } from '../../../component-library';
import { PatientFacialDetection } from '../../../components';
import { useTestContext } from '../../../context/testContext';
import { useReceiveMessage } from '../../../context/messageContext';
import { kaysOptotypes } from '../../../helpers/kaysOptotypes';
import { useOptotypeData } from '../../../helpers/reducers';
import Arrow from '../../../assets/img/upwards-arrow.svg';

const KaysOptotypes = () => {
  const { updateTestData } = useTestContext();
  const receivedMessage = useReceiveMessage();
  const {
    currentOptotypeData: { currentOptotypes, optotypeSize, crowdedOptotype, highlightedOptotype },
    updateOptotypeData,
  } = useOptotypeData();

  useEffect(() => {
    updateTestData({ testInProgress: true });
  }, [updateTestData]);

  useEffect(() => {
    //this receives "reducer" messages and dispatches the appropriate action.
    if (receivedMessage.type === 'useOptotypeReducer') {
      updateOptotypeData({ type: receivedMessage.action, payload: receivedMessage.payload });
    }
  }, [receivedMessage, updateOptotypeData, currentOptotypes]);

  return (
    <Flex>
      <PatientFacialDetection />
      <Flex bg='white' width='100vw' alignItems='center' height='100vh' justifyContent='center'>
        {currentOptotypes.map((opt, idx) => {
          return (
            <div
              key={`optotype-${opt}`}
              style={{
                position: 'relative',
                ...(!crowdedOptotype && { margin: `0 ${optotypeSize / 2}px` }),
                ...(crowdedOptotype && {
                  borderStyle: 'solid',
                  borderTopWidth: optotypeSize / 8,
                  borderRightWidth: currentOptotypes.length > 2 && idx < 4 ? 0 : optotypeSize / 8,
                  borderBottomWidth: optotypeSize / 8,
                  borderLeftWidth: optotypeSize / 8,
                  padding: optotypeSize / 3,
                }),
              }}
            >
              <Flex width={optotypeSize} height={optotypeSize}>
                {kaysOptotypes[opt]}
              </Flex>

              {highlightedOptotype === opt && (
                <img
                  src={Arrow}
                  alt='arrow highlighting optotype'
                  style={{
                    height: optotypeSize,
                    position: 'absolute',
                    top: `${optotypeSize * (1 + (crowdedOptotype ? 1 : 0.25))}px`,
                    left: '50%',
                    transform: 'translateX(-50%)',
                  }}
                />
              )}
            </div>
          );
        })}
      </Flex>
    </Flex>
  );
};

export default KaysOptotypes;
